/* =============================================
   GROVITA PRODUCT PAGE — JS Controller
   Gallery slider, tabs, sticky bar, quantity sync
   ============================================= */

(function () {
  'use strict';

  /* ----- GALLERY ----- */
  function initGallery(section) {
    const mainMedia = section.querySelector('[data-grovita-main-media]');
    const thumbsDesktop = section.querySelector('[data-grovita-thumbs]');
    const thumbsMobile = section.querySelector('[data-grovita-mobile-thumbs]');
    const prevBtn = section.querySelector('[data-grovita-prev]');
    const nextBtn = section.querySelector('[data-grovita-next]');

    if (!mainMedia) return;

    const slides = Array.from(mainMedia.querySelectorAll('.grovita-product__slide'));
    if (slides.length === 0) return;

    let currentIndex = slides.findIndex(s => s.classList.contains('is-active'));
    if (currentIndex === -1) currentIndex = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[currentIndex].classList.remove('is-active');
      slides[index].classList.add('is-active');
      currentIndex = index;

      // Update desktop thumbs
      if (thumbsDesktop) {
        thumbsDesktop.querySelectorAll('.grovita-product__thumb').forEach((t, i) => {
          t.classList.toggle('is-active', i === index);
        });
        const activeThumb = thumbsDesktop.querySelector('.grovita-product__thumb.is-active');
        if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      // Update mobile thumbs
      if (thumbsMobile) {
        thumbsMobile.querySelectorAll('.grovita-product__mobile-thumb').forEach((t, i) => {
          t.classList.toggle('is-active', i === index);
        });
        const activeThumb = thumbsMobile.querySelector('.grovita-product__mobile-thumb.is-active');
        if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    // Arrows
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

    // Thumb clicks (desktop)
    if (thumbsDesktop) {
      thumbsDesktop.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-thumb-index]');
        if (thumb) goTo(parseInt(thumb.dataset.thumbIndex, 10));
      });
    }

    // Thumb clicks (mobile)
    if (thumbsMobile) {
      thumbsMobile.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-thumb-index]');
        if (thumb) goTo(parseInt(thumb.dataset.thumbIndex, 10));
      });
    }

    // Touch swipe on main media
    let touchStartX = 0;
    mainMedia.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    mainMedia.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? goTo(currentIndex - 1) : goTo(currentIndex + 1);
      }
    }, { passive: true });

    section._galleryGoTo = goTo;

    // Hover-zoom: move transform-origin to cursor position
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      slides.forEach(slide => {
        const img = slide.querySelector('.grovita-product__main-img');
        if (!img) return;
        slide.addEventListener('mousemove', (e) => {
          const rect = slide.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        });
        slide.addEventListener('mouseleave', () => {
          img.style.transformOrigin = 'center center';
        });
      });
    }
  }

  /* ----- QUANTITY CONTROLS ----- */
  function initQuantity(section) {
    const qtyInput = section.querySelector('.grovita-product__qty-input');
    const minusBtn = section.querySelector('[data-grovita-qty-minus]');
    const plusBtn = section.querySelector('[data-grovita-qty-plus]');
    const stickyMinus = section.querySelector('[data-grovita-sticky-minus]');
    const stickyPlus = section.querySelector('[data-grovita-sticky-plus]');
    const stickyDisplay = section.querySelector('[data-grovita-sticky-qty-display]');

    if (!qtyInput) return;

    function getVal() { return parseInt(qtyInput.value, 10) || 1; }
    function getMin() { return parseInt(qtyInput.min, 10) || 1; }
    function getMax() { return qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity; }
    function getStep() { return parseInt(qtyInput.step, 10) || 1; }

    function setVal(v) {
      const clamped = Math.max(getMin(), Math.min(getMax(), v));
      qtyInput.value = clamped;
      if (stickyDisplay) stickyDisplay.textContent = clamped;
    }

    function decrease() { setVal(getVal() - getStep()); }
    function increase() { setVal(getVal() + getStep()); }

    if (minusBtn) minusBtn.addEventListener('click', decrease);
    if (plusBtn) plusBtn.addEventListener('click', increase);
    if (stickyMinus) stickyMinus.addEventListener('click', decrease);
    if (stickyPlus) stickyPlus.addEventListener('click', increase);

    qtyInput.addEventListener('change', () => {
      setVal(getVal());
    });

    // Sync sticky display initial
    if (stickyDisplay) stickyDisplay.textContent = getVal();
  }

  /* ----- TABS ----- */
  function initTabs(section) {
    const tabBtns = section.querySelectorAll('[data-grovita-tab]');
    const tabPanels = section.querySelectorAll('[data-grovita-panel]');

    if (tabBtns.length === 0) return;

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.grovitaTab;

        tabBtns.forEach(b => b.classList.remove('is-active'));
        tabPanels.forEach(p => p.classList.remove('is-active'));

        btn.classList.add('is-active');
        const panel = section.querySelector(`[data-grovita-panel="${target}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ----- STICKY BOTTOM BAR ----- */
  function initStickyBar(section) {
    const stickyBar = section.querySelector('[data-grovita-sticky-bar]');
    const atcBtn = section.querySelector('.grovita-product__atc-btn');

    if (!stickyBar) return;

    // Always visible on product page
    stickyBar.classList.add('is-visible');

    // Sticky ATC click → trigger main form submit
    const stickyAtc = section.querySelector('[data-grovita-sticky-atc]');
    if (stickyAtc && atcBtn) {
      stickyAtc.addEventListener('click', () => {
        atcBtn.click();
      });
    }
  }

  /* ----- WISHLIST TOGGLE ON PRODUCT PAGE ----- */
  function initWishlistToggle(section) {
    const btn = section.querySelector('[data-grovita-wishlist-toggle]');
    if (!btn) return;

    function updateVisual() {
      if (typeof GrovitaWishlist === 'undefined') return;
      const pid = btn.getAttribute('data-product-id');
      const isWished = GrovitaWishlist.has(pid);
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill', isWished ? 'currentColor' : 'none');
      }
      btn.classList.toggle('is-wishlisted', isWished);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof GrovitaWishlist === 'undefined') return;

      var productData = {
        id: String(btn.getAttribute('data-product-id')),
        title: btn.getAttribute('data-product-title') || 'Product',
        url: btn.getAttribute('data-product-url') || '/products/',
        price: btn.getAttribute('data-product-price') || '',
        image: btn.getAttribute('data-product-image') || '',
        variant_id: btn.getAttribute('data-variant-id') || null,
        available: true
      };

      GrovitaWishlist.toggle(productData.id, productData);

      btn.style.transform = 'scale(1.3)';
      setTimeout(function () { btn.style.transform = ''; }, 200);

      updateVisual();

      if (typeof GrovitaWishlistDrawer !== 'undefined') {
        GrovitaWishlistDrawer.open();
      }
    });

    updateVisual();
    document.addEventListener('grovita:wishlist:updated', updateVisual);
  }

  /* ----- MODALS (Size Guide / Delivery / Question) ----- */
  function initModals(section) {
    // Open buttons
    section.querySelectorAll('[data-grovita-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modalId = btn.getAttribute('data-grovita-open-modal');
        var modal = document.getElementById(modalId);
        if (modal) openModal(modal);
      });
    });

    // Close buttons + overlay clicks
    document.querySelectorAll('.grovita-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-grovita-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openModal = document.querySelector('.grovita-modal.is-open');
        if (openModal) closeModal(openModal);
      }
    });

    // Question form submit
    var form = document.querySelector('[data-grovita-question-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var successMsg = form.querySelector('[data-grovita-question-success]');
        var submitBtn = form.querySelector('.grovita-modal__submit');

        // Basic client-side validation
        var name = form.querySelector('[name="contact[name]"]');
        var email = form.querySelector('[name="contact[email]"]');
        var body = form.querySelector('[name="contact[body]"]');
        if (!name.value.trim() || !email.value.trim() || !body.value.trim()) return;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Verzenden...';
        }

        // Submit via Shopify contact form endpoint
        var formData = new FormData(form);
        formData.append('form_type', 'contact');
        formData.append('utf8', '\u2713');

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function () {
          form.reset();
          if (successMsg) successMsg.style.display = 'block';
          if (submitBtn) submitBtn.style.display = 'none';
          setTimeout(function () {
            var modal = form.closest('.grovita-modal');
            if (modal) closeModal(modal);
            // Reset form state for next open
            if (successMsg) successMsg.style.display = 'none';
            if (submitBtn) {
              submitBtn.style.display = '';
              submitBtn.disabled = false;
              submitBtn.textContent = 'Versturen';
            }
          }, 2500);
        }).catch(function () {
          // Even on error response the form was likely submitted
          form.reset();
          if (successMsg) successMsg.style.display = 'block';
          if (submitBtn) submitBtn.style.display = 'none';
          setTimeout(function () {
            var modal = form.closest('.grovita-modal');
            if (modal) closeModal(modal);
            if (successMsg) successMsg.style.display = 'none';
            if (submitBtn) {
              submitBtn.style.display = '';
              submitBtn.disabled = false;
              submitBtn.textContent = 'Versturen';
            }
          }, 2500);
        });
      });
    }
  }

  function openModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    // Only restore scroll if no other modals open
    if (!document.querySelector('.grovita-modal.is-open')) {
      document.body.style.overflow = '';
    }
  }

  /* ----- HEADER SPACING — measure nav and set exact padding ----- */
  function syncHeaderSpacing() {
    var header = document.querySelector('.grovita-header');
    var nav = header && header.querySelector('.grovita-header__nav');
    var product = document.querySelector('.grovita-product');
    if (!header || !nav || !product) return;

    var headerPadTop = parseFloat(getComputedStyle(header).paddingTop) || 20;
    // getBoundingClientRect().bottom is viewport-relative — correct for a fixed header.
    // Do NOT add window.scrollY: that inflates the value when the user has scrolled,
    // causing a visual jump every time a resize event fires (e.g. mobile URL bar hide).
    var navBottom = nav.getBoundingClientRect().bottom;
    product.style.paddingTop = (navBottom + headerPadTop) + 'px';
  }

  /* ----- SECTION INIT / DESTROY ----- */
  function initSection(container) {
    // Mark the body so CSS can scope product-page-only rules (e.g. sticky bar clearance).
    document.body.classList.add('grovita-page--product');

    const section = container.querySelector ? container : document;
    const root = section.querySelector('.grovita-product') || section;

    initGallery(root);
    initQuantity(root);
    initTabs(root);
    initStickyBar(root);
    initWishlistToggle(root);
    initModals(root);
  }

  function destroySection(container) {
    const root = container.querySelector('.grovita-product') || container;
    if (root._stickyObserver) root._stickyObserver.disconnect();
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSection(document);
      syncHeaderSpacing();
    });
  } else {
    initSection(document);
    syncHeaderSpacing();
  }

  // Re-sync only on viewport WIDTH changes.
  // Mobile browsers fire 'resize' when the URL bar shows/hides (height-only change),
  // which would incorrectly recalculate padding-top mid-scroll and cause a jump.
  var _lastVW = window.innerWidth;
  window.addEventListener('resize', function () {
    var vw = window.innerWidth;
    if (vw !== _lastVW) {
      _lastVW = vw;
      syncHeaderSpacing();
    }
  });

  // Shopify Theme Editor integration
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.grovita-product')) {
      initSection(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.querySelector('.grovita-product')) {
      destroySection(e.target);
    }
  });
})();
